// Helper izin per-peran (murni, port dari prototype). Dipakai lintas modul.
import type { Role } from '@core/types';

const anyOf = (r: Role, ...rs: Role[]): boolean => rs.includes(r);

export const canSeeModal = (r: Role): boolean => anyOf(r, 'Owner', 'Manager', 'SPV', 'Admin Finance');
// Segregation of duties (anti-fraud): PELUNASAN oleh CS (+ O/M override) · VERIFIKASI oleh Finance (+ O/M).
// Finance TAK boleh tandai-lunas, CS TAK boleh verifikasi → tak ada peran operasional yang bisa keduanya.
export const canMarkLunas = (r: Role): boolean => anyOf(r, 'Owner', 'Manager', 'CS');
export const canVerify = (r: Role): boolean => anyOf(r, 'Owner', 'Manager', 'Admin Finance');
export const canEditBayar = (r: Role): boolean => anyOf(r, 'Owner', 'Manager');
